import { render, staticRenderFns } from "./StripeConnector.vue?vue&type=template&id=54a8edca"
import script from "./StripeConnector.vue?vue&type=script&lang=js"
export * from "./StripeConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports